import EntityType from '@/models/Shared/EntityType';
import MessageDto from '@/models/Messages/MessageDto';
import ConversationStatus from '@/models/Conversations/ConversationStatus';

export default class ConversationDto {
    id = '';
    tenantId = '';
    createdAt: Date = new Date();
    createdByFirebaseUserId ='';
    status: ConversationStatus = ConversationStatus.WorkerCreated;
    conversationTopicId = '';
    conversationTopicType = 3;
    conversationTopicName = '';
    deskId = '';
    branchId = '';
    workerId = '';
    workerFirebaseUserId = '';
    workerDisplayName = '';
    workerAvatar = '';

    assignedToEntityId = '';
    assignedToEntityType: number;
    assignedToFirebaseUserId = '';
    assignedToDisplayName = '';
    assignedToAvatar = '';

    participantFirebaseUserIds: string[] = [];

    subject = '';
    lastMessageCreatedAt: Date = new Date();
    lastMessage: MessageDto = new MessageDto();
 
    bookingId = '';
    bookingRoleId = '';
    bookingRoleWorkerId = '';
    
    jobId = '';
    jobWorkerId = '';
    
    sequenceNumber = '';
    companyId = '';
    companyBrandName = '';
    locationId = '';
    locationBrandName = '';
    departmentId = '';
    departmentName = '';


}